import { Link, PDFDownloadLink } from '@react-pdf/renderer'
import { Button } from '@capcenter/shared';
import { Document, Page, Image, Text, View, StyleSheet } from '@react-pdf/renderer';
import { Property } from '../../../interfaces/interfaces';
import React from 'react'
import { toTitleCase } from '../../../utilities/util';
import numeral from 'numeral';
import CapcenterLogo from './CapcenterLogo.png'
import Bbb from './BBB.png'
import RealtorLogo from './RealtorLogo.png'
import EhoLogo from './EhoLogo.png'
import { useRecoilValue } from 'recoil';
import * as AppState from '../../../AppState';
import {Buffer} from 'buffer';
import { homeValueUrl } from '@capcenter/shared';
import { PdfSaveButton } from './ButtonComponent';

const pdfStyles = StyleSheet.create({
  page: {
    backgroundColor: '#FFFFFF',
    fontSize: 14,
    color:"#213035",
    paddingVertical: 40,
    paddingHorizontal: 40
  },
  section: {
    marginVertical: 17,
  }
});

interface pdfProps {
	property: Property;
	capCenter: boolean | undefined;
	onMarketDate: Date | undefined;
	staticMapSrc: string;
	photoCount: number;
	closeDate: Date;
  countyId: any;
}

export const PdfSaveLink = (props: pdfProps) => {
  const property = props.property;
	const [pdfDownload, setPdfDownload] = React.useState(false);

	const userOnMobile = useRecoilValue(AppState.gsIsMobile);

  const url = window.location.href;

  let photo = props.staticMapSrc;

  if (props.photoCount >= 1) {
    photo = property.Photos?.find((p: any) => p.order === 0)?.url || property.Photos[0].url;
  }

  const generateAddressArray = (): string[] => {
    const addressArray = [];
    property.StreetNumber && addressArray.push(property.StreetNumber);
    property.StreetDirPrefix && addressArray.push(property.StreetDirPrefix);
    property.StreetName && addressArray.push(property.StreetName);
    property.StreetSuffix && addressArray.push(property.StreetSuffix);
    property.StreetDirSuffix && addressArray.push(property.StreetDirSuffix);
    property.UnitNumber && addressArray.push(property.UnitNumber);
    (property.City ? addressArray.push(property.City) : property.PostalCity && addressArray.push(property.PostalCity));
    property.StateOrProvince && addressArray.push(property.StateOrProvince);
    property.PostalCode && addressArray.push(property.PostalCode);
    return addressArray
  }

  const dateListed = property.OnMarketDate ? new Date(property.OnMarketDate).toLocaleDateString('en-US', { timeZone: 'UTC' }):
    property.DerivedOnMarketTimestamp ? new Date(property.DerivedOnMarketTimestamp).toLocaleDateString('en-US', { timeZone: 'UTC' }):
    '--';

	const SavingsFigure = () => {
		return <Text>{property.CloseDate ? 'Sold' : 'Listing'} Price</Text>;
	};

  function titleCheck(str: string | undefined) {
    return str ? toTitleCase(str) : '';
  }

  function upperCheck(str: string | undefined) {
    return str ? str?.toUpperCase() : '';
  }
  if(!pdfDownload){
    return <Button
      title={`Download PDF for ${generateAddressArray().join(' ')}`}
      resetText
      className="font--base"
      variant="flat"
      size={userOnMobile ? 'sm' : 'md'}
      color={'gray'}
      label={
        userOnMobile?
        "Save PDF":
        "Download PDF"
      }
      onClick={()=>setPdfDownload(true)}
    />
  }
	return (
		<PDFDownloadLink document={  <Document title="CapCenter Property PDF" author='CapCenter' language='English'>
      <Page size="A4" style={pdfStyles.page}>
        <View style={[pdfStyles.section, {paddingHorizontal:"30%"}]}>
          <Link src="https://www.capcenter.com"><Image src={CapcenterLogo}></Image></Link>
        </View>
        <View style={[pdfStyles.section, {maxHeight:"30%"}]}>
          <Link src={url}><Image style={{objectFit:"contain"}} debug={false} cache={false}
          src={
            async ()=> fetch(`${homeValueUrl}v1/home-pdf-photo-stream`,
              {
                method: "POST",
                headers: {
                  'Content-Type': 'application/json', // Specify the content type as JSON if sending JSON data
                },
                body:JSON.stringify({url: photo})})
              .then(response=> {
                if(!response.ok){
                  throw new Error("Bad response");
                }
                return response.arrayBuffer()})
              .then(arrayBuffer=> Buffer.from(arrayBuffer))
              .catch(()=>props.staticMapSrc)
          }
          /></Link>
        </View>
        <View style={[pdfStyles.section, {fontSize: 20, textAlign:"center"}]}>
          <Link src={url} style={{color:"#003936"}}>
            <Text>
            {(property.StreetNumber ? `${property.StreetNumber} ` : '') +
              (property.StreetDirPrefix ? `${property.StreetDirPrefix} ` : '') +
              (property.StreetName ? `${titleCheck(property.StreetName)} ` : '') +
              (property.StreetSuffix ? `${titleCheck(property.StreetSuffix)} ` : '') +
              (property.StreetDirSuffix ? ` ${property.StreetDirSuffix} ` : '') +
              (property.UnitNumber ? ` Unit ${property.UnitNumber} ` : '')}
              {(property.City ? `${titleCheck(property.City)}, ` : property.PostalCity ? `${titleCheck(property.PostalCity)}, ` : '') +
                (property.StateOrProvince ? `${upperCheck(property.StateOrProvince)} ` : '') +
                (property.PostalCode ? `${titleCheck(property.PostalCode)}` : '')}
            </Text>
          </Link>
        </View>
        <View style={[pdfStyles.section, {fontSize: 16, textAlign:"center", display: 'flex', flexDirection:"row", justifyContent:"space-around", alignItems:"center"}]}>
          <View style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Text>
              ${property.ClosePrice ? property.ClosePrice : numeral(property.ListPrice).format() ? numeral(property.ListPrice).format() : "--"}
            </Text>
              {SavingsFigure()}
          </View>
          <Text>|</Text>
          <View style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Text>
              {property.BedroomsTotal ? property.BedroomsTotal : "--"}
            </Text>
            <Text>
              {property.BedroomsTotal && property.BedroomsTotal===1 ? `Bed`: `Beds`}
            </Text>
          </View>
          <Text>|</Text>
          <View style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Text>
              {property.RawMlsBathroomsTotal && property.RawMlsBathroomsTotal===1 ? `${property.RawMlsBathroomsTotal} Bathroom `: `${property.RawMlsBathroomsTotal} Bathrooms `}
            </Text>
            <Text>
              {property.BathroomsFull ? `${property.BathroomsFull} Full `: "-- Full"}
              {property.BathroomsHalf ? `${property.BathroomsHalf} Half `: "-- Half"}
            </Text>
          </View>
          <Text>|</Text>
          <View style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Text>
              {property.LivingArea && `${numeral(property.LivingArea).format()}`}
            </Text>
            <Text>
              Sq. Feet
            </Text>
          </View>
          <Text>
          </Text>
        </View>
        <View style={[pdfStyles.section, {fontSize: 14, textAlign:"left", display: 'flex', flexDirection:"row", justifyContent:"space-around"}]}>
          <View style={{display: "flex", flexDirection: "column"}}>
            <Text>Status: {property.MlsStatus}</Text>
            <Text>Date Listed: {dateListed}</Text>
            <Text>Roof: {property.Roof??"--"}</Text>
            <Text>Garage: {property.GarageYN?"Yes": "No"}</Text>
            <Text>Basement: {property.Basement?.[0]?? "--"}</Text>
            <Text>Water source: {property.WaterSource?? "--"}</Text>
          </View>
          <View style={{display: "flex", flexDirection: "column"}}>
            <Text>Year built: {property.YearBuilt ?? "--"}</Text>
            <Text>Lot Size: {property.LotSizeAcres ?? "--"} acres</Text>
            <Text>HOA: {property.AssociationFee?'Yes': 'No'}</Text>
            <Text>Stories: {property.StoriesTotal??"--"}</Text>
            <Text>Annual Tax: ${property.TaxAnnualAmount??"--"}</Text>
            <Text>Subdivision: {property.SubdivisionName??"--"}</Text>
          </View>
        </View>
        <View style={[pdfStyles.section, {marginHorizontal:"30%", maxHeight:"5%", textAlign:"center", display: 'flex', flexDirection:"row", justifyContent:"space-between", alignItems:"center"}]}>
          <View><Image src={RealtorLogo}></Image></View>
          <View><Image src={EhoLogo}></Image></View>
          <View style={{maxWidth:"36%"}}><Link src="https://www.bbb.org/us/va/glen-allen/profile/mortgage-broker/capcenter-0603-6000171"><Image style={{objectFit:"contain"}} src={Bbb}></Image></Link></View>
        </View>
        <View style={[pdfStyles.section, {
          position: 'absolute',
          fontSize: 8,
          bottom: 40,
          left: 40,
          right: 40,
          textAlign: 'center',
          color: 'grey',}]}>
          <Text>
          Restrictions apply. See CapCenter.com for details. Capital Center, LLC dba CapCenter is a licensed mortgage lender in Virginia, North Carolina, South Carolina, Maryland, Georgia, Florida, and the District of Columbia, NMLS ID #67717 (www.nmlsconsumeraccess.org), and a licensed real estate broker in in Virginia, Maryland, North Carolina, South Carolina, and the District of Columbia.
          </Text>
          <Text>
          Our primary office is located in Glen Allen, Virginia.
          </Text>
        </View>
      </Page>
    </Document>} fileName={
      `${generateAddressArray().join('-')}.pdf`
      }>
      {({ blob, url, loading, error }) =>
        <PdfSaveButton userOnMobile={userOnMobile} loading={loading} generateAddressArray={generateAddressArray} url={url}></PdfSaveButton>
      }
    </PDFDownloadLink>
	);
}
